/** @format */

import { useEffect, useState } from "react";
import Input from "../../extra/Input";
import SettingBox from "./SettingBox";
import { connect, useDispatch, useSelector } from "react-redux";
import { getSetting, updateSetting, handleToggleSwitch, handleSellerToggleSwitch } from "../../store/setting/setting.action";
import { getWithdraw } from "../../store/withdraw/withdraw.action";
import Button from "../../extra/Button";
import ToggleSwitch from "../../extra/ToggleSwitch";
import "react-quill-new/dist/quill.snow.css";
import InfoTooltip from "../../extra/InfoTooltip";
import { auctionSetting, chargesSetting, openAISetting, smtpSetting, withdrawalSetting, zegoApp } from "../../extra/infoContent";

const Setting = (props) => {
	const { setting } = useSelector((state) => state.setting);

	const dispatch = useDispatch();
	// box 1
	const [settingId, setSettingId] = useState("");
	const [zegoAppId, setZegoAppId] = useState("");
	const [paymentReminderForLiveAuction, setPaymentReminderForLiveAuction] = useState("");
	const [minPayout, setMinPayout] = useState("");
	const [paymentReminderForManualAuction, setPaymentReminderForManualAuction] = useState("");
	const [zegoAppSignIn, setZegoAppSignIn] = useState("");
	const [zegoServerSecret, setZegoServerSecret] = useState("");
	// box 2
	// const [privacyPolicyLink, setPrivacyPolicyLink] = useState("");
	// const [privacyPolicyText, setPrivacyPolicyText] = useState("");

	// SMTP Settings
	const [smtpHost, setSmtpHost] = useState("");
	const [smtpPort, setSmtpPort] = useState(587);
	const [smtpSecure, setSmtpSecure] = useState(false);
	const [smtpUser, setSmtpUser] = useState("");
	const [smtpPass, setSmtpPass] = useState("");
	const [smtpFromEmail, setSmtpFromEmail] = useState("");
	const [smtpFromName, setSmtpFromName] = useState("");

	// Support Contact (Help & Support screen)
	const [supportEmail, setSupportEmail] = useState("");
	const [supportPhone, setSupportPhone] = useState("");

	// const [termsAndConditionsLink, setTermsAndConditionsLink] = useState('');
	const [openaiApiKey, setOpenaiApiKey] = useState("");

	const [adminCommissionCharges, setAdminCommissionCharges] = useState("");

	const [isFakeData, setIsFakeData] = useState(false);
	const [legacyStaticKeyEnabled, setLegacyStaticKeyEnabled] = useState(true);

	// box 3

	// box 7
	const [isAddProductRequest, setIsAddProductRequest] = useState(false);
	const [isUpdateProductRequest, setIsUpdateProductRequest] = useState(false);

	const [addressProofRequired, setAddressProofRequired] = useState(setting?.addressProofRequired || false);
	const [addressProofActive, setAddressProofActive] = useState(setting?.addressProofActive || false);

	const [govIdRequired, setGovIdRequired] = useState(setting?.govIdRequired || false);
	const [govIdActive, setGovIdActive] = useState(setting?.govIdActive || false);

	const [registrationCertRequired, setRegistrationCertRequired] = useState(setting?.registrationCertRequired || false);
	const [registrationCertActive, setRegistrationCertActive] = useState(setting?.registrationCertActive || false);

	const [error, setError] = useState({
		zegoAppId: "",
		paymentReminderForLiveAuction: "",
		minPayout: "",
		paymentReminderForManualAuction: "",
		zegoAppSignIn: "",
		// privacyPolicyLink: "",
		smtpHost: "",
		smtpUser: "",
		smtpPass: "",
		// termsAndConditionsLink: "",
		openaiApiKey: "",
		// privacyPolicyText: "",
		// shippingCharges: "",
		withdrawCharges: "",
		withdrawLimit: "",
		adminCommissionCharges: "",
		razorPayId: "",
		razorSecretKey: "",
		stripePublishableKey: "",
		stripeSecretKey: "",
	});

	useEffect(() => {
		dispatch(getSetting());
	}, [dispatch]);

	useEffect(() => {
		dispatch(getWithdraw());
	}, [dispatch]);

	//onselect function of selecting multiple values

	//onRemove function for remove multiple values

	useEffect(() => {
		setSettingId(setting?._id);
		// box 1
		setZegoAppId(setting?.zegoAppId);
		setPaymentReminderForLiveAuction(setting?.paymentReminderForLiveAuction);
		setMinPayout(setting?.minPayout);
		setPaymentReminderForManualAuction(setting?.paymentReminderForManualAuction);
		setZegoAppSignIn("");
		setZegoServerSecret("");
		// box 2
		// setPrivacyPolicyLink(setting?.privacyPolicyLink);
		// setPrivacyPolicyText(setting?.privacyPolicyText);
		setIsFakeData(setting?.isFakeData);
		setLegacyStaticKeyEnabled(setting?.legacyStaticKeyEnabled !== false);

		// box 7
		setIsAddProductRequest(setting?.isAddProductRequest);
		setIsUpdateProductRequest(setting?.isUpdateProductRequest);
		setAdminCommissionCharges(setting?.adminCommissionCharges);

		// SMTP Settings
		setSmtpHost(setting?.smtpHost || "");
		setSmtpPort(setting?.smtpPort || 587);
		setSmtpSecure(setting?.smtpSecure || false);
		setSmtpUser(setting?.smtpUser || "");
		setSmtpPass("");
		setSmtpFromEmail(setting?.smtpFromEmail || "");
		setSmtpFromName(setting?.smtpFromName || "Declotr");

		// Support Contact
		setSupportEmail(setting?.supportEmail || "");
		setSupportPhone(setting?.supportPhone || "");

		// setTermsAndConditionsLink(setting?.termsAndConditionsLink || '');
		setOpenaiApiKey("");
	}, [setting]);

	const handleSubmit = () => {
		if (
			!zegoAppId ||
			!paymentReminderForLiveAuction ||
			!minPayout ||
			!paymentReminderForManualAuction ||
			// !privacyPolicyLink ||
			!smtpHost ||
			!smtpUser ||
			// !termsAndConditionsLink ||
			// !privacyPolicyText ||

			!adminCommissionCharges ||
			adminCommissionCharges <= 0
		) {
			let error = {};
			if (!zegoAppId) error.zegoAppId = "ZegoAppId Is Required ";
			if (!paymentReminderForLiveAuction) error.paymentReminderForLiveAuction = "Payment Reminder For Live Auction Is Required ";
			if (!minPayout) error.minPayout = "Min Payout Is Required ";
			if (!paymentReminderForManualAuction) error.paymentReminderForManualAuction = "Payment Reminder For Manual Auction Is Required ";
			// if (!privacyPolicyLink)
			//   error.privacyPolicyLink = "Privacy Policy Link Is Required ";
			if (!smtpHost) error.smtpHost = "SMTP Host Is Required ";
			if (!smtpUser) error.smtpUser = "SMTP Username Is Required ";
			// if (!termsAndConditionsLink)
			//   error.termsAndConditionsLink = "Terms And Conditions Link Is Required ";
			// if (!privacyPolicyText)
			//   error.privacyPolicyText = "Privacy Policy Text Is Required ";

			if (!adminCommissionCharges) error.adminCommissionCharges = "Admin Commission Charges Is Required";
			if (adminCommissionCharges <= 0) error.adminCommissionCharges = "Enter Correct Admin Commission Charges ";

			return setError({ ...error });
		} else {
			let settingData = {
				zegoAppId,
				paymentReminderForLiveAuction,
				minPayout,
				paymentReminderForManualAuction,
				// privacyPolicyLink,
				smtpHost,
				smtpPort,
				smtpSecure,
				smtpUser,
				smtpFromEmail,
				smtpFromName,
				supportEmail,
				supportPhone,
				// termsAndConditionsLink,
				// privacyPolicyText,
				adminCommissionCharges,
			};

			// Only send secret fields when the admin actually typed a new value.
			// Backend keeps the existing value when the field is omitted/empty.
			if (zegoAppSignIn) settingData.zegoAppSignIn = zegoAppSignIn;
			if (zegoServerSecret) settingData.zegoServerSecret = zegoServerSecret;
			if (smtpPass) settingData.smtpPass = smtpPass;
			if (openaiApiKey) settingData.openaiApiKey = openaiApiKey;

			props.updateSetting(settingData, setting?._id);
		}
	};

	const handleClick = (field, toggleType) => {
		console.log("field", field, "toggleType", toggleType);

		if (toggleType) {
			// Seller document toggles (addressProof, govId, registrationCert) with isActive/isRequired
			dispatch(handleSellerToggleSwitch(setting._id, field, toggleType));
		} else {
			// Simple on/off toggles (productRequest, updateProductRequest, isFakeData)
			dispatch(handleToggleSwitch(setting._id, field, setting));
		}
	};

	return (
		<>
			<div className='mainup'>
				<div className='settingHeader primeHeader'>
					<div className='col-12 headname' style={{ marginTop: "15px", marginBottom: "-5px" }}>
						App Setting{" "}
					</div>
				</div>
				<div className='settingMain'>
					<div className='row' style={{ margin: "0px 2px" }}>
						{/*-------------- Box 1 --------------*/}
						<SettingBox title={`Zegocloud Setting`}>
							<Input
								type={`text`}
								label={`Zegocloud App Id`}
								value={zegoAppId}
								newClass={`col-12`}
								placeholder={`Enter Your Zegocloud App Id....`}
								errorMessage={error.zegoAppId && error.zegoAppId}
								onChange={(e) => {
									setZegoAppId(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											zegoAppId: `Zegocloud App Id Is Required`,
										});
									} else {
										return setError({
											...error,
											zegoAppId: "",
										});
									}
								}}
							/>
							<Input
								type={`password`}
								label={`Zegocloud App Sign In`}
								value={zegoAppSignIn}
								newClass={`col-12`}
								placeholder={`Leave blank to keep saved value`}
								errorMessage={error.zegoAppSignIn && error.zegoAppSignIn}
								onChange={(e) => {
									setZegoAppSignIn(e.target.value);
								}}
							/>{" "}
							<Input
								type={`password`}
								label={`Zegocloud Server Secret`}
								value={zegoServerSecret}
								newClass={`col-12`}
								placeholder={`Leave blank to keep saved value`}
								errorMessage={error.zegoServerSecret && error.zegoServerSecret}
								onChange={(e) => {
									setZegoServerSecret(e.target.value);
								}}
							/>
							<div
								style={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}>
								<InfoTooltip title='Zego App Id' content={zegoApp} />
							</div>
						</SettingBox>

						<SettingBox title={`Become Seller Setting`} className='mb-5'>
							<div className='d-flex justify-content-between align-items-center mb-2'>
								<div style={{ width: "200px" }} />
								<span className='fw-semibold' style={{ width: "80px", textAlign: "center" }}>
									Require
								</span>
								<span className='fw-semibold' style={{ width: "80px", textAlign: "center" }}>
									Active
								</span>
							</div>

							{/* Utility Bill (Proof of Address) Row */}
							<div className='d-flex justify-content-between align-items-center mt-2'>
								<h5 className='me-2 fw-semibold' style={{ width: "200px" }}>
									Utility Bill (Proof of Address)
								</h5>
								<div style={{ width: "80px", textAlign: "center" }}>
									<ToggleSwitch
										value={setting?.addressProof?.isRequired}
										onClick={() => {
											handleClick("addressProof", "isRequired");
											if (setting?.addressProof?.isActive === false && setting?.addressProof?.isRequired === false) {
												setTimeout(() => {
													handleClick("addressProof", "isActive");
												}, 1000); // 2 second delay, apko jitna chahiye adjust kar sakte hain
											}
										}}
									/>
								</div>
								<div style={{ width: "80px", textAlign: "center" }}>
									<ToggleSwitch
										value={setting?.addressProof?.isActive}
										onClick={() => {
											handleClick("addressProof", "isActive");
											if (setting?.addressProof?.isRequired === true && setting?.addressProof?.isActive === true) {
												setTimeout(() => {
													handleClick("addressProof", "isRequired");
												}, 1000);
											}
										}}
									/>
								</div>
							</div>

							{/* Proof of Identification Row */}
							<div className='d-flex justify-content-between align-items-center mt-2'>
								<h5 className='me-2 fw-semibold' style={{ width: "200px" }}>
									Proof of Identification
								</h5>
								<div style={{ width: "80px", textAlign: "center" }}>
									<ToggleSwitch
										value={setting?.govId?.isRequired}
										onClick={() => {
											handleClick("govId", "isRequired");
											if (setting?.govId?.isActive === false && setting?.govId?.isRequired === false) {
												setTimeout(() => {
													handleClick("govId", "isActive");
												}, 1000);
											}
										}}
									/>
								</div>
								<div style={{ width: "80px", textAlign: "center" }}>
									<ToggleSwitch
										value={setting?.govId?.isActive}
										onClick={() => {
											handleClick("govId", "isActive");
											if (setting?.govId?.isRequired === true && setting?.govId?.isActive === true) {
												setTimeout(() => {
													handleClick("govId", "isRequired");
												}, 1000);
											}
										}}
									/>
								</div>
							</div>

							{/* Business Registration Certificate Row */}
							<div className='d-flex justify-content-between align-items-center mt-2'>
								<h5 className='me-2 fw-semibold' style={{ width: "200px", whiteSpace: "nowrap" }}>
									Business Registration Certificate
								</h5>
								<div style={{ width: "80px", textAlign: "center" }}>
									<ToggleSwitch
										value={setting?.registrationCert?.isRequired}
										onClick={() => {
											handleClick("registrationCert", "isRequired");
											if (setting?.registrationCert?.isActive === false && setting?.registrationCert?.isRequired === false) {
												setTimeout(() => {
													handleClick("registrationCert", "isActive");
												}, 1000);
											}
										}}
									/>
								</div>
								<div style={{ width: "80px", textAlign: "center" }}>
									<ToggleSwitch
										value={setting?.registrationCert?.isActive}
										onClick={() => {
											handleClick("registrationCert", "isActive");
											if (setting?.registrationCert?.isRequired === true && setting?.registrationCert?.isActive === true) {
												setTimeout(() => {
													handleClick("registrationCert", "isRequired");
												}, 1000);
											}
										}}
									/>
								</div>
							</div>
						</SettingBox>

						{/* Box 7 */}
						<SettingBox
							title={`Add Product Request`}
							title2={`New product request enable/disable for seller`}
							toggleSwitch={{
								switchValue: isAddProductRequest,
								handleClick: () => {
									handleClick("productRequest");
								},
							}}></SettingBox>
						<SettingBox
							title={`Update Product Request`}
							title2={`Enable/disable product request update for seller`}
							toggleSwitch={{
								switchValue: isUpdateProductRequest,
								handleClick: () => {
									handleClick("updateProductRequest");
								},
							}}></SettingBox>

						<SettingBox title={`Charges Setting`}>
							<Input
								type={`number`}
								label={`Admin Commission Charges (%)`}
								value={adminCommissionCharges}
								newClass={`col-6`}
								placeholder={`Enter You Admin Commission Charges`}
								errorMessage={error.adminCommissionCharges && error.adminCommissionCharges}
								onChange={(e) => {
									setAdminCommissionCharges(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											adminCommissionCharges: `Admin Commission Charges Is Required`,
										});
									} else {
										return setError({
											...error,
											adminCommissionCharges: "",
										});
									}
								}}
							/>

							<div
								style={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}>
								<InfoTooltip title='Charges Setting' content={chargesSetting} />
							</div>
						</SettingBox>

						<SettingBox title={`Auction Payment Settings`}>
							<Input
								type={`number`}
								label={`Payment Reminder For Live Auction (Minutes)`}
								value={paymentReminderForLiveAuction}
								newClass={`col-6 pb-2`}
								placeholder={`e.g., 2`}
								errorMessage={error.paymentReminderForLiveAuction && error.paymentReminderForLiveAuction}
								onChange={(e) => {
									setPaymentReminderForLiveAuction(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											paymentReminderForLiveAuction: `Payment Reminder For Live Auction Is Required`,
										});
									} else {
										return setError({
											...error,
											paymentReminderForLiveAuction: "",
										});
									}
								}}
							/>
							<Input
								type={`number`}
								label={`Payment Reminder For Manual Auction (Minutes)`}
								value={paymentReminderForManualAuction}
								newClass={`col-6 pb-2`}
								placeholder={`e.g., 1440 (24 hours)`}
								errorMessage={error.paymentReminderForManualAuction && error.paymentReminderForManualAuction}
								onChange={(e) => {
									setPaymentReminderForManualAuction(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											paymentReminderForManualAuction: `Payment Reminder For Manual Auction Is Required`,
										});
									} else {
										return setError({
											...error,
											paymentReminderForManualAuction: "",
										});
									}
								}}
							/>
							<div
								style={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}>
								<InfoTooltip title='Auction Payment Settings' content={auctionSetting} />
							</div>
						</SettingBox>

						<SettingBox title={`SMTP Email Settings`}>
							<Input
								type={`text`}
								label={`SMTP Host`}
								value={smtpHost}
								newClass={`col-md-6`}
								placeholder={`e.g., smtp.gmail.com`}
								errorMessage={error.smtpHost && error.smtpHost}
								onChange={(e) => {
									setSmtpHost(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											smtpHost: `SMTP Host Is Required`,
										});
									} else {
										return setError({
											...error,
											smtpHost: "",
										});
									}
								}}
							/>
							<Input type={`number`} label={`SMTP Port`} value={smtpPort} newClass={`col-md-6`} placeholder={`e.g., 587`} onChange={(e) => setSmtpPort(parseInt(e.target.value) || 587)} />
							<Input
								type={`text`}
								label={`SMTP Username`}
								value={smtpUser}
								newClass={`col-md-6`}
								placeholder={`Your email username`}
								errorMessage={error.smtpUser && error.smtpUser}
								onChange={(e) => {
									setSmtpUser(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											smtpUser: `SMTP Username Is Required`,
										});
									} else {
										return setError({
											...error,
											smtpUser: "",
										});
									}
								}}
							/>
							<Input
								type={`password`}
								label={`SMTP Password`}
								value={smtpPass}
								newClass={`col-md-6`}
								placeholder={`Leave blank to keep saved value`}
								errorMessage={error.smtpPass && error.smtpPass}
								onChange={(e) => {
									setSmtpPass(e.target.value);
								}}
							/>
							<Input type={`text`} label={`From Email`} value={smtpFromEmail} newClass={`col-md-6`} placeholder={`noreply@yourdomain.com`} onChange={(e) => setSmtpFromEmail(e.target.value)} />
							<Input type={`text`} label={`From Name`} value={smtpFromName} newClass={`col-md-6`} placeholder={`Declotr`} onChange={(e) => setSmtpFromName(e.target.value)} />
							<div className='col-md-6 d-flex align-items-center gap-3' style={{ marginTop: "10px" }}>
								<label className='form-label mb-0'>Use SSL (Port 465)</label>
								<ToggleSwitch value={smtpSecure} onClick={() => setSmtpSecure(!smtpSecure)} />
							</div>

							<div
								style={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}>
								<InfoTooltip title='SMTP Email Settings' content={smtpSetting} />
							</div>
						</SettingBox>

						<SettingBox title={`Support Contact`} title2={`Shown on the Help & Support screen and used as the recipient for the contact form`}>
							<Input type={`text`} label={`Support Email (Contact Us)`} value={supportEmail} newClass={`col-md-6`} placeholder={`info@declotr.com`} onChange={(e) => setSupportEmail(e.target.value)} />
							<Input type={`text`} label={`Support Phone (Call Us)`} value={supportPhone} newClass={`col-md-6`} placeholder={`+234 800 000 0000`} onChange={(e) => setSupportPhone(e.target.value)} />
						</SettingBox>

						<SettingBox title={`Minimum Withdrawal Limit (Seller) (${setting?.currency?.currencyCode})`}>
							<Input
								type={`number`}
								label={`Minimum Withdrawal Amount`}
								value={minPayout}
								newClass={`col-12`}
								placeholder={`Enter Amount....`}
								errorMessage={error.minPayout && error.minPayout}
								onChange={(e) => {
									setMinPayout(e.target.value);
									if (!e.target.value) {
										return setError({
											...error,
											minPayout: `Minimum Withdrawal Amount Is Required`,
										});
									} else {
										return setError({
											...error,
											minPayout: "",
										});
									}
								}}
							/>

							<div
								style={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}>
								<InfoTooltip title='Withdrawal Setting' content={withdrawalSetting} />
							</div>
						</SettingBox>

						<SettingBox title={`Open AI Key Setting`}>
							<Input
								type={`password`}
								label={`Open AI Key`}
								value={openaiApiKey}
								newClass={`col-12`}
								placeholder={`Leave blank to keep saved value`}
								errorMessage={error.openaiApiKey && error.openaiApiKey}
								onChange={(e) => {
									setOpenaiApiKey(e.target.value);
								}}
							/>

							<div
								style={{
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}>
								<InfoTooltip title='Open AI Setting' content={openAISetting} />
							</div>
						</SettingBox>

						<SettingBox title={`Push Notification Setting`}>
							<div className='prime-input'>
								<label
									className='float-left styleForTitle'
									style={{
										color: "#94a3b8",
									}}>
									Expo Push Notifications
								</label>
								<p className='form-control mt-2' style={{ backgroundColor: "#f8fafc", padding: "12px", borderRadius: "8px", color: "#64748b" }}>
									Push notifications are now handled via the <strong>Expo Push API</strong>. No Firebase service account key is required. The mobile app automatically registers Expo Push Tokens when users log in.
								</p>
							</div>
						</SettingBox>

						<SettingBox
							title={`Fake Data`}
							title2={`Disable/Enable fake data in app`}
							toggleSwitch={{
								switchName: " ",
								switchValue: isFakeData,
								handleClick: () => {
									handleClick("isFakeData");
								},
							}}></SettingBox>

						<SettingBox
							title={`API Authentication — Legacy Static Key`}
							title2={`When ON (default) the API still accepts the legacy static \`key\` header so older mobile builds keep working. Turn OFF only after all users have updated to a JWT-aware app version. Login / OTP routes always remain reachable.`}
							toggleSwitch={{
								switchName: " ",
								switchValue: legacyStaticKeyEnabled,
								handleClick: () => {
									handleClick("legacyStaticKey");
								},
							}}></SettingBox>
						{/* <SettingBox title={`Become Seller Setting`}>
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="me-2 fw-semibold">Address Proof</h5>
                <div className="d-flex gap-5">
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Require</span>
                    <ToggleSwitch
                      value={setting?.addressProof?.isRequired}
                      onClick={() => handleClick("addressProof", "isRequired")}
                    />
                  </div>
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Active</span>
                    <ToggleSwitch
                      value={setting?.addressProof?.isActive}
                      onClick={() => handleClick("addressProof", "isActive")}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <h5 className="me-2 fw-semibold">Government ID</h5>
                <div className="d-flex gap-5">
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Require</span>
                    <ToggleSwitch
                      value={setting?.govId?.isRequired}
                      onClick={() => handleClick("govId", "isRequired")}
                    />
                  </div>
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Active</span>
                    <ToggleSwitch
                      value={setting?.govId?.isActive}
                      onClick={() => handleClick("govId", "isActive")}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <h5 className="me-2 fw-semibold">Registration Certificate</h5>
                <div className="d-flex gap-5">
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Require</span>
                    <ToggleSwitch
                      value={setting?.registrationCert?.isRequired}
                      onClick={() => handleClick("registrationCert", "isRequired")}
                    />
                  </div>
                  <div className="d-flex">
                    <span className="me-2 fw-semibold">Active</span>
                    <ToggleSwitch
                      value={setting?.registrationCert?.isActive}
                      onClick={() => handleClick("registrationCert", "isActive")}
                    />
                  </div>
                </div>
              </div>
            </SettingBox> */}
					</div>
					<div className='row mt-5'>
						<div className='col-12 d-flex justify-content-end'>
							<Button newClass={`whiteFont`} btnName={`Submit`} btnColor={`btnBlackPrime`} style={{ width: "90px", borderRadius: "8px" }} onClick={(e) => handleSubmit(e)} />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default connect(null, {
	getSetting,
	updateSetting,
	handleToggleSwitch,
	getWithdraw,
})(Setting);
